import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const deleteMacro = api(async function deleteMacro({ id }) {
    if (!id) return false
    return mutate(
        gql`
            mutation DeleteMacro($id: String!) {
                deleteMacro(id: $id)
            }
        `,
        { id },
        { returns: "deleteMacro" }
    )
})
